import { put } from 'redux-saga/effects';
import { getCookie } from '../../../utils/cookie';
import {
  APP_STORE_REVIEW_COOKIE_NAME,
  APP_STORE_REVIEW_COOKIE_VALUE,
} from '../../../constants/appStoreReview';
import { setLocalGameLaunchMode } from '../../actions/app/initialization';

export function* checkLocalGameLaunchMode() {
  const cookie = getCookie(APP_STORE_REVIEW_COOKIE_NAME) || '';

  if (cookie === APP_STORE_REVIEW_COOKIE_VALUE) {
    yield put(setLocalGameLaunchMode(true));
  }
}
